import type { ReactNode } from "react";
import { Navigate } from "react-router";
import { useVenue } from "./VenueContext";
import { useGuaranteePolicy } from "./guaranteePolicy";

/**
 * ADVISORY guard for the no-show output surfaces (deposits / failed guarantees). The nav already hard-hides
 * their links when the policy is off; this only catches a direct deep-link, redirecting to the venue overview
 * rather than showing a permanently-empty page. The server stays authoritative on every action.
 */
export function RequireGuaranteePolicy({
  surface,
  children,
}: {
  surface: "noShow" | "deposit";
  children: ReactNode;
}) {
  const { venueId } = useVenue();
  const { noShowEnabled, depositEnabled } = useGuaranteePolicy();
  const enabled = surface === "noShow" ? noShowEnabled : depositEnabled;
  if (!enabled) return <Navigate to={`/v/${venueId}/overview`} replace />;
  return <>{children}</>;
}
